import {FC} from "react";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {NavLink, useLocation} from "react-router-dom";
import {getHeaderLogo, getHeaderLogoMobile} from "modules/utils/helpers";
import {GAME_ZONE_URL, OTHER_LANG_LINK, subMenuRouting} from "modules/constants";
import {ProjectLinks} from "components";
import {SubHeaderLink} from "./SubHeaderLink";
import {ExternalSubHeaderLink} from "./ExternalSubHeaderLink";
import {breakpoints} from "assets/theme";

const Wrapper = styled.div`
	width: 100%;
	padding: 0 20px;
	background: ${({theme}) => theme.colorPalette.black};
	color: ${({theme}) => theme.colorPalette.white};
`;

const Container = styled.div`
	max-width: 1240px;
	margin: 0 auto;
	display: none;
	align-items: stretch;

	@media (min-width: 961px) {
		gap: 12px;
	}

	@media (min-width: ${breakpoints.medium}) {
		display: flex;
	}
`;

const MobileContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	@media (min-width: ${breakpoints.medium}) {
		display: none;
	}
`;

const Logo = styled.img`
	height: 64px;
	vertical-align: middle;

	@media (min-width: ${breakpoints.medium}) {
		height: 50px;
		margin: 5px 24px 5px 0;
	}
`;

export const SubHeader: FC = () => {
	const {i18n} = useTranslation();
	const logo = getHeaderLogo(i18n.language);
	const mobileLogo = getHeaderLogoMobile(i18n.language);
	const {search} = useLocation();

	return (
		<Wrapper className="sub-header">
			<MobileContainer>
				<NavLink to={`/${search}`}>
					<Logo src={mobileLogo} alt="CFL gamezone" />
				</NavLink>
			</MobileContainer>

			<Container>
				<NavLink to={`/${search}`}>
					<Logo src={logo} alt="CFL gamezone" />
				</NavLink>

				{subMenuRouting.map((link) => (
					<SubHeaderLink key={link.title} {...link} />
				))}

				<ExternalSubHeaderLink
					href={`${OTHER_LANG_LINK}${search}`}
					title={"sub_header.links.other_lang"}
				/>

				<ExternalSubHeaderLink
					href={`${GAME_ZONE_URL}profile${search}`}
					title={"sub_header.links.profile"}
					target="_blank"
					rel="noreferrer noopener"
					isPrivate
				/>

				<ProjectLinks />
			</Container>
		</Wrapper>
	);
};
